<template>
  <v-form
    v-model="valid"
    ref="form"
    lazy-validation
    class="pa-4 px-4"
    @submit.prevent="createSubcategory"
  >
    <v-container>
      <div class="d-flex justify-end">
        <v-btn
          tile
          color="primary"
          @click="$router.push({ name: 'subcategory-index' })"
        >
          <v-icon left>
            arrow_back
          </v-icon>
          Back
        </v-btn>
      </div>
      <v-row class="mb-2">
        <v-col>
          <v-text-field
            :counter="35"
            label="Name"
            v-model="subcategory.name"
            :rules="nameRules"
          ></v-text-field>
          <v-autocomplete
            v-model="subcategory.productCategoryId"
            :items="categories"
            filled
            dense
            label="Select Category"
            item-text="name"
            item-value="id"
          ></v-autocomplete>
          <v-autocomplete
            v-model="subcategory.productSubCategoryTypeId"
            :items="subcategoryTypes"
            filled
            dense
            label="Select Subcategory Type"
            item-text="name"
            item-value="id"
          ></v-autocomplete>
          <v-textarea
            :counter="200"
            label="Description"
            :rules="descriptionRules"
            v-model="subcategory.description"
            required
          ></v-textarea>
        </v-col>
      </v-row>

      <v-btn type="submit" class="mx-0 mt-4">Create</v-btn>
    </v-container>
  </v-form>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      subcategory: {
        name: "",
        description: "",
        productCategoryId: "",
        productSubCategoryTypeId: ""
      },
      nameRules: [
        v => !!v || "Name is required",
        v => v.length >= 3 || "Name must be at least 3 characters",
        v => v.length <= 50 || "Name must be less than than 35 characters"
      ],
      descriptionRules: [
        v => !!v || "Description is required",
        v => v.length >= 10 || "Description must be at least 8 digits",
        v => v.length <= 200 || "Description must be less than than 20 digits"
      ]
    };
  },
  mounted() {
    this.$store.dispatch("categories/LOAD_CATEGORIES", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("subcategorytypes/LOAD_SUBCATEGORY_TYPES", {
      from: 0,
      to: 0
    });
  },
  computed: {
    ...mapState({
      categories: state => state.categories.categories,
      subcategoryTypes: state => state.subcategorytypes.subcategoryTypes
    })
  },
  methods: {
    async createSubcategory() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Adding Subcategory...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch(
          "subcategories/CREATE_SUBCATEGORY",
          this.subcategory
        );
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Product subcategory brand has been added",
          icon: "info"
        });
      }
    }
  }
};
</script>
